import { CompanyApi } from 'api/CompanyApi';
import { backendApiClient } from 'container/backendApiClient';

export const companyApi: CompanyApi = new CompanyApi(backendApiClient);
